import { Languages } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const LanguageToggle = () => {
  const { lang, toggle, t } = useLanguage();
  return (
    <button
      data-testid="language-toggle"
      onClick={toggle}
      aria-label="Switch language"
      className="group flex items-center gap-2 rounded-full border border-amber-200/25 bg-white/5 px-4 py-2 backdrop-blur-md transition-colors hover:border-amber-200/60 hover:bg-white/10"
    >
      <Languages className="h-4 w-4 text-amber-200" />
      <span className="text-xs font-medium tracking-[0.15em] text-amber-50">
        {lang === "en" ? "हिं" : "EN"}
      </span>
    </button>
  );
};
